/**
 * Quién cobra en Smarty Drop.
 *
 * ── UNA SOLA CAJA ──────────────────────────────────────────────────────────────────────────────
 * Desde el 21-sep-2026 toda la plata del dropshipper entra a Smarty: las recargas de saldo y los
 * pagos de un pedido por igual. El almacén no le cobra nada al revendedor — lo suyo se lo debe
 * Smarty, y eso vive en el libro (cuenta `por_pagar`).
 *
 * 🚨 POR QUÉ HAY UN ARCHIVO PARA ESTO. Esa decisión cambió la base pero no llegó al menú: «Cobros»
 *    se le mostraba SÓLO a un proveedor, y Smarty HQ no es proveedor. Así que el único negocio que
 *    puede aprobar un pago era el único que no tenía cómo llegar a la pantalla. Tres pagos
 *    quedaron declarados y sin revisar —S/ 86— hasta que el founder preguntó «¿por qué no lo veo?».
 *
 * ⭐ SE PREGUNTA POR EL SLUG, NO POR EL UUID. `fn_tenant_plataforma()` resuelve
 *    `select id from tenants where slug = 'smarty-hq'`: preguntar por el mismo slug es usar la
 *    MISMA fuente de verdad que la base, en vez de una copia del uuid pegada en el panel — que es
 *    lo que había, y que ya estaba escrita a mano en una pantalla.
 */

/** El slug del negocio de la plataforma. Igual que `fn_tenant_plataforma()` en la base. */
export const SLUG_DE_LA_PLATAFORMA = 'smarty-hq';

/** ¿El negocio con el que estoy actuando es Smarty, la plataforma? */
export function esLaPlataforma(storeSlug: string | null | undefined): boolean {
  return storeSlug === SLUG_DE_LA_PLATAFORMA;
}
